$(document).ready(function () {

  //trigger
  $(document).on("click",".ajax-cart-button", function () {
    $(this).closest("body").find(".product-form__buttons-add-to-card .product-form__submit").trigger("click");
  });
  
  //ajax add to cart code
  $(document).on("click",".ajax-add-to-cart-button",function() {
  var ajaxVariantID = $(this).attr('ajax-variant-id');
  addToCartJS(1,ajaxVariantID,$(this));
});
function addToCartJS(qty, variantID, btn) {
    // Open the cart drawer
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionsToRender = cartDrawer.getSectionsToRender().map((section) => section.id)
    var sections_url = window.location.pathname;
    // Send request to add item to cart
    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ "quantity": qty, "id": variantID, "sections" : sectionsToRender, "sections_url" : sections_url})
    })
    .then(response => response.json())
    .then(response => {
      cartDrawer.renderContents(response);
      // cartDrawer.open();
      if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
    })
    .catch(error => {
        console.error("Error adding item to cart:", error);
    });
  } 

     var interval = setInterval(function () {
      if($(".klaviyo-bis-trigger").length > 0) {
        var textAppend = $('.klaviyo-bis-trigger');
         $(".product-form__buttons-cover").append(textAppend);
        textAppend.css("display","block");
        clearInterval(interval);
      }
    }, 100);


  // $(document).on("mouseenter", ".template-fior-555 .newiconw_text--div a", function() {
  //   var newiconwText = $(this).find("span").html();
  //   $(this).closest(".colorvariants").find(".color-label .colorvariantsnameprints").text(newiconwText);
  // });
  // $(document).on("mouseleave", ".template-fior-555 .newiconw_text--div a", function() {
  //   firstactiveElementOnLoad()
  // });
  // function firstactiveElementOnLoad(){
  //   var firstActiveElement = $(".template-fior-555 .newiconw_text--div a").first(); 
  //   if (firstActiveElement.length) {
  //     var newiconwText = firstActiveElement.find("span").html();
  //     firstActiveElement.closest(".colorvariants").find(".color-label .colorvariantsnameprints").text(newiconwText);
  //   }
  // }
  // firstactiveElementOnLoad()

  if ($("body").hasClass("template-fior-555")) {
      setTimeout(function () {
        $(".faq-section-product .accordion details").first().find("summary").trigger("click");
      }, 500); // Adjust the delay time if needed
   }
});